<template>
  <v-card
    class="py-2 max-shadow"
    dark
    :color="color"
  >
    <v-card-text class="py-1">
      <v-layout row>
        <v-flex>
          <v-layout
            row
            fill-height
            wrap
          >
            <v-flex xs12>
              <div class="subheading font-weight-bold">
                {{ titleUppercase }}
              </div>
            </v-flex>
            <v-flex xs12>
              <v-icon large>
                {{ icon }}
              </v-icon>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex>
          <v-layout
            column
            fill-height
            wrap
            justify-end
            align-end
          >
            <div class="display-1">
              {{ valuePrefix }} {{ value }}
            </div>
            <div class="subheading">
              {{ subTitle }}
            </div>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: 'CountWidget',
  props: {
    color: {
      type: String,
      default: 'primary',
      required: true
    },
    icon: {
      type: String,
      default: 'home',
      required: true
    },
    title: {
      type: String,
      default: '',
      required: true
    },
    subTitle: {
      type: String,
      default: '',
      required: false
    },
    value: {
      type: Number,
      default: 0,
      required: true
    },
    valuePrefix: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  computed: {
    titleUppercase() {
      return this.title.toUpperCase();
    }
  }
};
</script>

